import propTypes from 'prop-types';
import intl from 'react-intl-universal';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';
import { NotFoundPage, Home, About, Header, PageFade } from '@components';
import 'babel-polyfill';
import '@styles/application.scss';

// locale data
const LOCALES = [
  {
    name: 'English',
    value: 'en-US',
  },
  {
    name: 'Português',
    value: 'pt-BR',
  },
  {
    name: 'Spanish',
    value: 'es',
  },
];

class App extends Component {
  constructor(props) {
    super(props);
    const currentLocale = LOCALES[0].value;

    intl.init({
      currentLocale,
      locales: {
        [currentLocale]: require(`../../../locales/${currentLocale}.json`),
      },
    });
  }

  render() {
    const { location } = this.props;
    return (
      <main className="main">
        <Header />
        <div>
          <TransitionGroup>
            <PageFade key={location.pathname}>
              <Switch location={location}>
                <Route exact path="/" component={Home} />
                <Route exact path="/about/" component={About} />
                <Route component={NotFoundPage} />
              </Switch>
            </PageFade>
          </TransitionGroup>
        </div>
      </main>
    );
  }
}

App.propTypes = {
  location: propTypes.object.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/components/enviroments/App/App.jsx